var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMaintenanceRefuel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 7.23L19.53 7.22L15.81 3.5L14.75 4.56L16.86 6.67C15.92 7.03 15.25 7.93 15.25 9C15.25 10.38 16.37 11.5 17.75 11.5C18.11 11.5 18.44 11.42 18.75 11.29V18.5C18.75 19.05 18.3 19.5 17.75 19.5C17.2 19.5 16.75 19.05 16.75 18.5V14C16.75 12.9 15.85 12 14.75 12H13.75V5C13.75 3.9 12.85 3 11.75 3H5.75C4.65 3 3.75 3.9 3.75 5V21H13.75V13.5H15.25V18.5C15.25 19.88 16.37 21 17.75 21C19.13 21 20.25 19.88 20.25 18.5V9C20.25 8.31 19.97 7.68 19.52 7.23ZM11.75 19H5.75V12H11.75V19ZM11.75 10H5.75V5H11.75V10ZM17.75 10C17.2 10 16.75 9.55 16.75 9C16.75 8.45 17.2 8 17.75 8C18.3 8 18.75 8.45 18.75 9C18.75 9.55 18.3 10 17.75 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaintenanceRefuel);
export default __webpack_public_path__ + "static/media/icon-maintenance-refuel.a6a83ad2e4fb94f43491d3266011ad9a.svg";
export { ForwardRef as ReactComponent };